<template>
    <div class="content new-booking">
        <iframe :src="checkoutUrl" v-if="checkoutUrl" scrolling="auto" id="new-booking-iframe" width="100%" height="100%"></iframe>
    </div>
</template>

<script>
    import {Api} from '../../../api';
    import {AppModel} from '../../../models';
    import {EventBus} from '../../../utils';

    const CHECKOUT_URL = process.env.CHECKOUT_URL || 'http://localhost:8080';

    export default {
        name: 'booking-new',

        created() {
            this.setCheckoutUrl();
            EventBus.$on(EventBus.BOOTSTRAP_DONE, this.setCheckoutUrl.bind(this));

            window.bookingCreated = this.onBookingCreated.bind(this);
            window.bookingCreatedBack = this.onBookingCreatedBack.bind(this);
        },

        data() {
            return {
                checkoutUrl: '',
                iframeHeight: 500,
            };
        },

        methods: {
            setCheckoutUrl() {
                if(AppModel.activeCampground) {
                    this.checkoutUrl = CHECKOUT_URL + '/de/' + AppModel.activeCampground.slug + '?token=' + Api.user.getToken() + '&mcadmin=1';
                }
            },

            onBookingCreated(bookingId) {
                window.scrollTo(0, 0);
            },

            onBookingCreatedBack() {
                this.$router.push({name: 'bookings'});
            },
        },
    };
</script>

<style lang="scss">
    @import 'booking-new.scss';
</style>



// WEBPACK FOOTER //
// src/views/pages/booking-new/bookingNew.vue